export default {
  title: 'Testrestaurants',
  description:
    'Jeder Partner kann ein Restaurant als Testrestaurant markieren. Es funktioniert wie jedes andere Restaurant und wird nie abgerechnet. Übersteigt sein Monatsumsatz den Schwellenwert, geht ein Slack-Alarm raus.',
  empty: 'Kein Partner hat ein Testrestaurant.',
  columns: {
    partner: 'Partner',
    restaurant: 'Restaurant',
    designated: 'Als Test markiert',
    gmv: 'GMV diesen Monat',
  },
  statuses: {
    live: 'Live',
    paused: 'Offline',
    suspended: 'Gesperrt',
  },
  gmv: {
    converted: '≈ {{amount}}',
    no_rate: 'Kein Wechselkurs hinterlegt',
  },
  actions: {
    remove: 'Test-Markierung entfernen',
  },
  toasts: {
    load_error: 'Die Testrestaurants konnten nicht geladen werden.',
  },
};
